import { Button, Drawer, Form, Input, Select, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { IBaseDrawerModel } from "../../../Types";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import OrganisationsService, {
  Department_Type,
  DepartmentTypeList,
  IDepttRequestModel,
  IOrganiseData,
  ISubUnitData,
} from "../../Services/Organisations/OrganisationsService";
import { IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "../../Services/ItemsService";
import { IDropdownProps } from "../Settings/SettingVoucherTemplate";

const AddDepttModel = ({
  isModalOpen,
  setIsModalOpen,
  id,
  setTrigger,
}: IBaseDrawerModel) => {
  const [form] = Form.useForm<IDepttRequestModel>();
  const { currentClient } = useClient();
  const [loading, setLoading] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [orgList, setOrgList] = useState<IOrganiseData[]>([]);
  const [selOrg, setSelOrg] = useState<string>("");
  const [subUnitList, setSubUnitList] = useState<ISubUnitData[]>([]);

  const saveData = async (formData: IDepttRequestModel) => {
    setLoading(true);
    await OrganisationsService.postDepartment(currentClient?.id!, formData, id!)
      .then((val: IApiResponse<IIdNameModel>) => {
        openNotification(
          "success",
          `${val?.result?.name} department ${
            id ? "updated" : "added"
          } successfully`
        );
        setIsModalOpen({
          open: false,
          id: "",
        });
        setLoading(false);
        setTrigger && setTrigger((prev) => !prev);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };

  const submitForm = (val: IDepttRequestModel) => {
    saveData(val);
  };

  const getData = async () => {
    setLoading(true);
    await OrganisationsService.getDepartment(currentClient?.id!, id!)
      .then((val: IDepttRequestModel | null) => {
        setSelOrg(val?.orgId as string);
        let formValues = {
          depttName: val?.depttName,
          orgId: val?.orgId,
          subUnitId: val?.subUnitId,
          depttType: val?.depttType,
        };

        form.setFieldsValue(formValues);
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (id) getData();
  }, [id]);

  console.log("Test1: ", subUnitList);
  console.log(
    "Test2: ",

    subUnitList.filter((subUnit: ISubUnitData) => subUnit.orgId === selOrg)
  );
  console.log(
    "Test3: ",
    subUnitList.map((subUnit: ISubUnitData) => ({
      label: subUnit.subUnitName,
      value: subUnit.id,
      key: subUnit.id,
      title: "",
    }))
  );

  const getOrgList = async () => {
    setLoading(true);
    await OrganisationsService.getOrganisationsList(currentClient?.id!)
      .then((val: IOrganiseData[] | null) => {
        setOrgList(
          val?.map((org: IOrganiseData) => ({
            id: org.id,
            orgName: org.orgName,
          })) || []
        );
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  const getSubUnitList = async () => {
    setLoading(true);
    await OrganisationsService.getSubUnitsList(currentClient?.id!)
      .then((val: ISubUnitData[] | null) => {
        setSubUnitList(
          val?.map((subUnit: ISubUnitData) => ({
            id: subUnit.id,
            orgName: subUnit.orgName,
            orgId: subUnit.orgId,
            subUnitName: subUnit.subUnitName,
          })) || []
        );
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    getOrgList();
    getSubUnitList();
  }, [currentClient?.id]);

  return (
    <Drawer
      open={isModalOpen}
      onClose={() =>
        setIsModalOpen({
          open: false,
          id: "",
        })
      }
      title={`${id ? "Update" : "Save"} department`}
      width={"30vw"}
      extra={
        <Space>
          <Button
            disabled={loading}
            onClick={() => {
              form.resetFields();
              setIsModalOpen({
                open: false,
                id: "",
              });
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            loading={loading}
            type="primary"
            onClick={() => {
              form.validateFields().then(submitForm);
            }}
          >
            {`${id ? "Update" : "Save"}`}
          </Button>
        </Space>
      }
    >
      <Form name="deptt" form={form} disabled={loading} layout="vertical">
        <Form.Item
          name="depttName"
          label="Department's Name"
          rules={[
            { required: true },
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]{2,49}$/,
              message: "Value's length must be between 3 and 50",
            },
          ]}
        >
          <Input
            type="text"
            maxLength={50}
            minLength={3}
            placeholder="Enter name here..."
          ></Input>
        </Form.Item>
        <Form.Item
          name="depttType"
          label="Department Type"
          rules={[{ required: true, message: "Please select department type" }]}
        >
          <Select
            placeholder="Select type"
            options={DepartmentTypeList.map(
              (deptt: IDropdownProps<Department_Type>) => ({
                label: deptt.label,
                value: deptt.value,
                key: deptt.key,
                title: "",
              })
            )}
          ></Select>
        </Form.Item>
        <Form.Item
          name="orgId"
          label="Organisation"
          rules={[{ required: true, message: "Please select organisation" }]}
        >
          <Select
            placeholder="Select organisation"
            onSelect={(val: string) => {
              form.setFieldValue("subUnitId", undefined);
              setSelOrg(val);
            }}
            options={orgList.map((org: IOrganiseData) => ({
              label: org.orgName,
              value: org.id,
              key: org.id,
              title: "",
            }))}
          ></Select>
        </Form.Item>
        <Form.Item
          name="subUnitId"
          label="Sub Unit"
          rules={[{ required: true, message: "Please select sub unit" }]}
        >
          <Select
            disabled={selOrg === ""}
            placeholder="Select sub unit"
            options={subUnitList
              .filter((subUnit: ISubUnitData) => subUnit.orgId === selOrg)
              .map((subUnit: ISubUnitData) => ({
                label: subUnit.subUnitName,
                value: subUnit.id,
                key: subUnit.id,
                title: "",
              }))}
          ></Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddDepttModel;
